<template>
  <div class="countdown mt-3 p-0" v-if="duration.totalSeconds > 0">
    <b-row no-gutters>
      <b-col cols="12" sm="3" md="3" v-if="duration.days > 0" class="mb-3 mb-sm-0">
        <div class="countdown-box">
          <div class="countdown-value">{{ duration.days }}</div>
          <div class="countdown-label">Days</div>
        </div>
      </b-col>
      <b-col cols="4" sm="3" md="3">
        <div class="countdown-box">
          <div class="countdown-value">{{ String(duration.hours).padStart(2, '0') }}</div>
          <div class="countdown-label">Hours</div>
        </div>
      </b-col>
      <b-col cols="4" sm="3" md="3">
        <div class="countdown-box">
          <div class="countdown-value">{{ String(duration.minutes).padStart(2, '0') }}</div>
          <div class="countdown-label d-none d-md-block">Minutes</div>
          <div class="countdown-label d-block d-md-none">Mins</div>
        </div>
      </b-col>
      <b-col cols="4" sm="3" md="3">
        <div class="countdown-box">
          <div class="countdown-value">{{ String(duration.seconds).padStart(2, '0') }}</div>
          <div class="countdown-label d-none d-md-block">Seconds</div>
          <div class="countdown-label d-block d-md-none">Secs</div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    date: {
      type: Date,
      required: true
    }
  },
  data() {
    return {
      timer: null,
      duration: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        totalSeconds: 0
      }
    }
  },
  mounted() {
    if (this.date > new Date()) {
      this.updateContent();
      this.startTimer();
    }
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.timer = setInterval(this.updateContent, 1000);
    },
    updateContent() {
      const now = new Date();
      const distance = this.date - now;
      if (distance < 0) {
        this.stopTimer();
        this.duration = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          totalSeconds: 0
        }
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const totalSeconds = Math.floor(distance / 1000);
        this.duration = { days, hours, minutes, seconds, totalSeconds };
      }
      if (this.duration.totalSeconds === 0) {
        window.location.reload();
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
}

</script>

<style scoped>
.countdown {
  padding: 1rem;
}

.countdown-box {
  background: linear-gradient(135deg, var(--cb-primary-50) 0%, var(--cb-secondary-100) 100%);
  border-radius: 12px;
  padding: 1.5rem 1rem;
  margin-right: 1rem;
  min-width: 100px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.countdown-value {
  font-size: 3rem;
  font-weight: bold;
  color: white;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.countdown-label {
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
}

@media (max-width: 576px) {
  .countdown-box {
    min-width: 70px;
    padding: 1rem 0.5rem;
  }

  .countdown-value {
    font-size: 2rem;
  }

  .countdown-label {
    font-size: 0.75rem;
  }
}
</style>